import client from './client';

const login = (email, password) => {
  console.log(email, password);
  const data = new FormData();
  data.append('username', email);
  data.append('password', password);
  return client.post('user/m.login.php', data);
};

const forgot = (email) => {
  const data = new FormData();
  data.append('email', email);
  return client.post('user/m.forgot_password.php', data);
};

const otp = (password, otp) => {
  const data = new FormData();
  // data.append('username', email);
  data.append('user_reset_code', otp);
  data.append('password', password);
  return client.post('user/m.forgot_password.php', data);
};

const fetch = (access_token) => {
  const data = new FormData();
  data.append('access_token', access_token);
  return client.post('user/m.fetch_user.php', data);
};

const update = (userInfo, token) => {
  const data = new FormData();
  data.append('access_token', token);
  data.append('user_name', userInfo.user_name);
  data.append('email', userInfo.email);
  // data.append('user', userInfo.email);
  // data.append('password', userInfo.password);
  data.append('user_city', userInfo.user_city);
  data.append('user_country', userInfo.user_country);
  data.append('user_zip', userInfo.user_zip);
  return client.post('user/m.update_user.php', data);
};

export default {
  login,
  forgot,
  fetch,
  update,
  otp,
};
